export default __webpack_public_path__ + "static/media/disciplinewillofmettle.f7034856.png";